export const CLIENT_DESIGNATIONS = {
  CLIENT: "Client"
}

export const EMPLOYEE_DESIGNATIONS = {
  SALES_ASSOCIATE: "Sales Associate",
  KMT_ASSOCIATE: "KMT Associate",
  CLIENT_SERVICES: "CSPOC"
}